import { DefaultTheme } from "styled-components/dist/types";

export const lightTheme: DefaultTheme = {
  bgColor: "#f5f6fa",
  textColor: "#2f3640",
  accentColor: "#8ec6ff",
  loadingColor: "black",
}

export const darkTheme: DefaultTheme = {
  bgColor: "#2f3640",
  textColor: "#f5f6fa",
  accentColor: "#9c88ff",
  loadingColor: "white",
}